import axios from 'axios'
import { AppUrls } from '../../services/Globals';
import { Config } from '../../services/Config';

export const groupActorsFunctions = {}

groupActorsFunctions.nextStage = (obj) => {
  if (sessionStorage.getItem('token')) {
    //Configuración
    let config = {
      pathname: `/${obj.nextComponent}`,
      //pathname: `/DynamicFormComponent`,
      state: {
        stageName: obj.stageName,
        stageId: obj.stageId,
        stage: obj.stage,
        folioId: obj.folioId,
        actorId: obj.actorId,
        searchFiles: obj.searchFiles,
      }
    }
    //Objeto lleno
    obj.navigate(config)
  }
  else {
    alert("No se encontró usuario.")
  }
}

groupActorsFunctions.docRequest = async (data) => {

  let handleResponse = (response) => {
    let respObject = response.data;
    if (!respObject.IsOK) {
      let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
      let error = (respObject.Body || responseObject);
      return Promise.reject(error);
    } else {
      console.log('response', respObject)
      return respObject;
    }
  }

  return axios.post(
    AppUrls.RegisterActor,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)

}

